import { createStrings } from '@utils/local';

export const staffStrings = createStrings({
  ja: {
    staff_id: 'スタッフID',
    name: '名前',
    last_name: '姓',
    first_name: '名',
    role: '権限グループ',
    email: 'メール',
    cellphone: '携帯電話番号',
    landline: '固定電話番号',
    lastLoginTime: '前回ログインした時間',
    emailNotVerified: '未認証',
    resendEmail: '認証メールを再送信する',
  },
});
